module.exports = globalThis.__PLADA_MODULES__["motion/react"];